import { render, staticRenderFns } from "./export-proof-edit.vue?vue&type=template&id=0322e13a"
import script from "./export-proof-edit.vue?vue&type=script&lang=js"
export * from "./export-proof-edit.vue?vue&type=script&lang=js"
import style0 from "./export-proof-edit.vue?vue&type=style&index=0&id=0322e13a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports